import { ICON__pen } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';

interface Props {
  item: DTOSearchSettings;
  setIsShowInputUpdateName: (value: boolean) => void;
}

export const SButtonHistoryListItemUpdateName: React.FC<Props> = ({ item, setIsShowInputUpdateName }) => {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   * EVENTS
   */
  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    setIsShowInputUpdateName(true);
  };

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="w-7"
      size="square-5"
      variant="no-border-on-component"
      onClick={onClick}
      iconClassNameBase={`!w-3 !h-3`}
      iconClassNameHovered={`!text-bar-foreground`}
      iconClassNameNonHovered={`!text-bar`}
      Icon={ICON__pen}
    />
  );
};
